import { render } from "./story_select.vue?vue&type=template&id=f24bd122&lang=pug"
import script from "./story_select.vue?vue&type=script&lang=js"
export * from "./story_select.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__